import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export default function AnimatedStat({ value, suffix = "", label, index = 0 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);
  const numeric = typeof value === "number";

  useEffect(() => {
    if (!inView || !numeric) return;
    let start = 0;
    const duration = 1400;
    const startTs = performance.now();
    let rafId;
    const tick = (now) => {
      const p = Math.min(1, (now - startTs) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) rafId = requestAnimationFrame(tick);
    };
    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [inView, value, numeric]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, delay: index * 0.1, ease: [0.2, 0.8, 0.2, 1] }}
      className="border-t border-white/10 pt-6"
      data-testid={`stat-${label.replace(/\s+/g, "-").toLowerCase()}`}
    >
      <div className="font-serif-display text-[color:var(--dk-gold)] text-4xl md:text-5xl xl:text-6xl leading-none tracking-tighter">
        {numeric ? n : value}<span className="text-[color:var(--dk-red)]">{suffix}</span>
      </div>
      <p className="mt-4 text-[10px] uppercase tracking-overline text-white/60">{label}</p>
    </motion.div>
  );
}
